import React, {useState, useEffect} from 'react';
import { readGlobalState } from '../../Functions/operations';
import {appids} from './appids';

export default function PriceFeed(props : {pair : string}) {
  const [prices, setPrices] : any = useState([]);

  useEffect(() => {
    const priceNames = Object.keys(appids);
    priceNames.forEach(priceName => {
      readGlobalState('GORAINEMNXSLMAHGHCK5ZW3LPP7VV5NO2QGWB47QEWNW76KG6UTZ346DCY', appids[priceName])
        .then((res : any) => {
          const priceObject = {
            price: res,
            name: priceName,
            appID: appids[priceName]
          }
          if(priceObject.price != 0)
            setPrices((prices: any) => [...prices, priceObject])
        })
    })
  }, []);

  return (
    <div style={{minHeight: '35em'}} className="mx-10 bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200">
      <div className="px-4 py-5 sm:px-6">
        <h2 className="text-2xl font-bold pb leading-7 text-gray-900 sm:text-3xl sm:truncate">
          USD Pairs
        </h2>
      </div>
      <dl   className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
        {
          prices.map((priceObject : any) => {
            return (
              <div key={priceObject.appID} className="px-4 py-5 bg-white shadow rounded-lg overflow-hidden sm:p-6">
                <p> {priceObject.name} : {priceObject.price} </p>
                <p> App ID # : <a style={{color: 'blue'}} href={`https://testnet.algoexplorer.io/application/${priceObject.appID}`} > {priceObject.appID}</a>   </p>
              </div>
            )
          })
        }
      </dl>
    </div>
  );
}
